<template>
  <div>
    <v-row no-gutters class="mb-6">
      <v-col cols="12" :md="8" class="wrapperWidthBottom">
        <v-row no-gutters justify="space-between">
          <div class="text-h5 font-weight-bold black--text mb-4">
            <translate>Golf played</translate>
          </div>
        </v-row>
        <v-row no-gutters align="baseline">
          <v-col cols="12" :sm="9">
            <SelectMultiCourse
              ref="dropdow"
              :placeholder="$gettext('Search golf course')"
              class="fromSearch__search rounded-0 text-h6 font-weight-regular"
              iconAppend="far fa-magnifying-glass"
              action='searchCourse'
              :multiple="true"
              :isEmit="true"
              @getSelected="getSelected"
            />
          </v-col>
          <v-col cols="12" :sm="3" class="text-right px-md-3 pt-3 pt-sm-0">
            <v-btn
              color="primary"
              small
              width="100%"
              class="text-none font-weight-bold text-h6 py-6"
              @click="addGolfCourse()"
            >
              <v-icon class="fal fa-circle-plus pr-3"></v-icon>
              <translate>Add</translate>
            </v-btn>
          </v-col>
        </v-row>
        <div>
          <template v-if="listGolfCourse.length !== 0">
            <CardRanking
              v-for="(item, idx) in listGolfCourse"
              :key="idx"
              :data="item"
              :isFlag="true"
              :idx="idx + 1"
              :isDelete="true"
              @deleteGolfCourse="deleteGolfCourse"
            />
          </template>
          <InfiniteLoad @loading="loadMore" :disabled="endData" />
        </div>
      </v-col>
      <v-col cols="12" :md="4"></v-col>
    </v-row>
  </div>
</template>
<script>
import { mergeByKey } from "@/utils/helper.js";
import InfiniteLoad from "@/components/InfiniteLoad/InfiniteLoad";
import CardRanking from "@/components/Ranking/CardRanking";
import GolfCourseService from "@/services/GolfCourseService";
import SelectMultiCourse from "@/components/Forms/SelectMultiCourse";
export default {
  name: "GolfPlayed",
  components: { CardRanking, InfiniteLoad, SelectMultiCourse },
  data: () => ({
    courseSelected: [],
    listGolfCourse: [],
    currentPage: 0,
    totalPages: 0,
    endData: false,
  }),
  methods: {
    isOpenScore() {
      console.log(this.$refs.dialogScore.isOpenDialog);
      this.$refs.dialogScore.isOpenDialog = true;
    },
    getSelected(value) {
      this.courseSelected = value;
    },
    async deleteGolfCourse(data) {
      await GolfCourseService.deleteCoursePlayer(data);
      this.listGolfCourse = this.listGolfCourse.filter(function (ele) {
        return ele.id != data.id;
      });
      this.$store.dispatch("setTotalCoursePlayed", -1); //set +/- CoursePlayed
    },
    async addGolfCourse() {
      if (this.courseSelected.length !== 0) {
      const listCourse = this.courseSelected.map(item => item.id)
      const courseStr = listCourse.toString().replace(/,/g,'-')
      if (courseStr) {
      let res = await this.$store.dispatch("addCoursePlayer", {
        id: courseStr,
      });
      if (res.error) {
        let errorText = this.$gettext('Server error')
        if(res.error.message == 'cant create another CourseUser') {
          errorText = this.$gettext('You have already added this golf course')
        }
        this.$toast.alert(errorText);

      } else {
        await this.getListCoursePlayer((this.currentPage = 1));
        this.$toast.success(this.$gettext(`Add course player success`));
        this.$store.dispatch("setTotalCoursePlayed", +listCourse.length); //set +/- CoursePlayed
        this.$refs.dropdow.reset()
        this.courseSelected = []
        }
      }
    }
    },
    async getListCoursePlayer(page) {
      let result = [];
      let listCourse = await GolfCourseService.getCoursePlayer({ page });
      if (!listCourse.error)
        result = listCourse.list.map((item) => item.course);
      //set totalPages
      this.totalPages = listCourse.totalPages;

      this.listGolfCourse = mergeByKey(this.listGolfCourse, result, "id");
    },
    async loadMore() {
      this.currentPage += 1;
      await this.getListCoursePlayer(this.currentPage);
      if (this.currentPage >= this.totalPages) {
        this.endData = true;
        return;
      }
    },
  },
  mounted() {
    window.scrollBy(0, 1); //fix listen scroll
    // this.listGolfCourse = await this.getListCoursePlayer(this.currentPage);
  },
};
</script>

<style lang="scss">
.wrapperAvatarBox {
  margin-top: -90px;
}
.tableScore {
  width: 100%;
}
.wrapperTable {
  padding: 20px 100px !important;
  tr {
    text-align: center;
  }
  tbody tr:nth-of-type(odd) {
    background-color: #edf6ff;
  }
}
</style>
